import { BlockRegistration } from './block-contract';
import { BlockRegistry } from './block-registry';

/** Optional presentation side of module registration. No module is required to supply a block. */
export interface ModuleBlockRegistration {
  readonly code: string;
  readonly version: number;
  readonly blocks: readonly BlockRegistration[];
}

/** Build privately so invalid/duplicate registrations never leave a partially installed registry. */
export function createModuleBlockRegistry(modules: readonly ModuleBlockRegistration[]): BlockRegistry {
  const registry = new BlockRegistry();
  const codes = new Set<string>();
  for (const module of modules) {
    if (!/^[a-z][a-z0-9]*(?:[.-][a-z0-9]+)*$/.test(module.code)
      || !Number.isSafeInteger(module.version) || module.version < 1 || codes.has(module.code)) {
      throw new Error('Module compositions require a unique code and positive version.');
    }
    codes.add(module.code);
    for (const block of module.blocks) registry.register(block);
  }
  return registry;
}
